import { render, staticRenderFns } from "./NewsFour.vue?vue&type=template&id=fdde1b5c&scoped=true"
import script from "./NewsFour.vue?vue&type=script&lang=js"
export * from "./NewsFour.vue?vue&type=script&lang=js"
import style0 from "./NewsFour.vue?vue&type=style&index=0&id=fdde1b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde1b5c",
  null
  
)

export default component.exports